export function getObjectIndex(state, value, field = 'id') {
    return state.findIndex((object) => {
        return object[field] === value
    })
}
